/**
 * Tabla de zonas de entrada/media/alta del esquema de remuneración NZ.
 * Única fuente de verdad — consumida por MetricsLiquidacionTab.tsx (UI) y por
 * nzLiquidacion.ts (cálculo puro). Vive en un módulo sin dependencias de React/UI
 * para poder importarse desde utils sin arrastrar la cadena de imports del componente.
 */

export type RemuneracionZone = 'entrada' | 'media' | 'alta';

export interface RemuneracionTier {
  zone: RemuneracionZone;
  range: string;
  amount: string;
}

export const REMUNERACION_TIERS: RemuneracionTier[] = [
  { zone: 'entrada', range: '15 – 19', amount: '$170' },
  { zone: 'entrada', range: '20 – 25', amount: '$230' },
  { zone: 'entrada', range: '26 – 30', amount: '$300' },
  { zone: 'entrada', range: '31 – 35', amount: '$360' },
  { zone: 'entrada', range: '36 – 40', amount: '$420' },
  { zone: 'entrada', range: '41 – 45', amount: '$480' },
  { zone: 'entrada', range: '46 – 50', amount: '$540' },
  { zone: 'entrada', range: '51 – 55', amount: '$600' },
  { zone: 'entrada', range: '56 – 60', amount: '$660' },
  { zone: 'media', range: '61 – 70', amount: '$770' },
  { zone: 'media', range: '71 – 80', amount: '$900' },
  { zone: 'media', range: '81 – 90', amount: '$1.030' },
  { zone: 'media', range: '91 – 100', amount: '$1.160' },
  { zone: 'alta', range: '101 – 110', amount: '$1.340' },
  { zone: 'alta', range: '111 – 120', amount: '$1.540' },
  { zone: 'alta', range: '121 – 130', amount: '$1.760' },
  { zone: 'alta', range: '130+', amount: '$2.000' },
];

export const REMUNERACION_ZONE_LABELS: Record<RemuneracionZone, string> = {
  entrada: 'Zona de entrada',
  media: 'Zona media',
  alta: 'Zona alta — acelerado',
};
